module.exports = "/_next/static/images/GenerativeAI@2x-3f22f71d62bd8d7b090093334b0f8318.webp";